import React, {useState, useContext, useEffect} from "react";
import Box from "@mui/material/Box";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Button from "@mui/material/Button";
import moment from "moment";
import {LoadingContext} from "@hoc/loading";
import {MessageContext} from "@hoc/messageNotification";
import {update} from "@api/barcodesLimit";
import {Typography} from "@mui/material";
import {addNullForEmptyField} from "@services/helper";
import {renderForm} from "@components/Form/renderForm";
import {validation} from "../../../../services/validation";
import {getTotalIssued} from "../../../../api/barcodes";
import { getHeaders } from "../../../../api/barcodesLimit";
import {getTimeZoneValue} from "../../../../api/timeZone";

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    main: {
        margin: '5px 0'
    }

});

export const UpdateBarcodesLimit = ({data, handleClose}) => {
        const onCallback = (e) => {
            columns.forEach((column) => {
                if (column.name === e.target.name) {
                    column.value = e.target.value;
                    column.error = '';
                }
            })
            setColumns([...columns]);
        }
        const columnsData = [
            {name: 'newAmount', headerName: 'New Amount', type: 'number', value: 0, onCallback: onCallback},
        ];

        const {id, from, benefitId, until} = data;
        const classes = useStyles();
        const [columns, setColumns] = useState(columnsData);
        const {setLoading} = useContext(LoadingContext);
        const {setErrorMessage} = useContext(MessageContext);
        const [totalIssued, setTotalIssued] = useState(null);
        const [totalCreated, setTotalCreated] = useState(null);

        const handleSubmit = async (event) => {
            event.preventDefault();
            setLoading(true);
            setErrorMessage(null);

            try {
                const data = new FormData(event.currentTarget);
                const obj = {};
                columns.forEach((column) => {
                    switch (column.type) {
                        case 'date':
                            const formatted = moment(data.get(column.name), 'MM/DD/YYYY').tz(getTimeZoneValue()).hour(0).minute(0).format();
                            
                            obj[column.name] = formatted;
                            break;
                        case 'array':
                            obj[column.name] = [];
                            break;
                        default:
                            obj[column.name] = data.get(column.name)
                    }
                })
                if(benefitId) {
                    obj.benefitId = benefitId;
                }
                addNullForEmptyField(obj);
                await update(id, obj);
                handleClose();
            } catch (e) {
                validation(e, columns, (columns) => {
                    return setColumns([...columns]);
                })
                setErrorMessage(e);
            }
            setLoading(false);
        }



        useEffect(() => {
            const loadBarcodeLimit = async () => {
                try {
                    setLoading(true);
                    setErrorMessage(null);
                    const fromAndUntil = {
                        from: from,
                        until: until
                    }
                    const resObj = await getTotalIssued(benefitId, fromAndUntil);
                    const headers = await getHeaders({benefitId: benefitId, status: "AVAILABLE"})
                    setTotalIssued(resObj.issued);
                    setTotalCreated(headers[1].total);
                } catch (e) {
                    setErrorMessage(e);
                }
                setLoading(false);
            }

            loadBarcodeLimit();
        }, [benefitId, setLoading, setErrorMessage, from, until])

        return (
            <Box
                className={classes.root}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                component="form"
                flexDirection={"column"}
                onSubmit={handleSubmit}
                noValidate
            >
                {totalIssued && totalCreated && <Box><Typography fontSize={22} component={'h3'}>Total {totalCreated} Issued {totalIssued} barcodes</Typography></Box>}
                <Box><Typography component={'h3'} fontSize={22}>You can only update future or current limits</Typography></Box>
                <Box
                    className={classes.main}
                >

                    {
                        columns.map((data, key) => {
                            return renderForm(data, key);
                        })
                    }
                </Box>
                <Button
                    type="submit"
                    variant="contained"
                >
                    Save
                </Button>
            </Box>
        );
    }
;